import React from "react";
import { ReconciliationModal } from "./ReconciliationModal";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var opsComponents = {
    ReconciliationModal: ReconciliationModal
};
export default opsComponents;
